export interface IWhitelistPayload {
  plateNumber: string;
  parkingLotId: string;
  type: string;
  ownerName: string;
  company: string;
  reason: string;
  expiresAt: string;
  timeFrom: string;
  timeTo: string;
  maxEntriesPerDay: number;
  isActive: boolean;
  addedBy: string;
}

export interface IWhitelistItem {
  id: string;
  parkingLotId: string;
  plateNumber: string;
  type: IWhitelistTypeEnum;
  ownerName: string;
  company: string;
  reason: string;
  expiresAt: string;
  timeFrom: string;
  timeTo: string;
  maxEntriesPerDay: number;
  isActive: boolean;
  addedBy: string;
}

export enum IWhitelistTypeEnum {
  FreeAccess = 'FreeAccess',
  Discount = 'Discount',
  GateOnlyAccess = 'GateOnlyAccess',
}

export const IWhitelistTypeLabel: Record<IWhitelistTypeEnum, string> = {
  [IWhitelistTypeEnum.FreeAccess]: 'ADMIN_WHITELIST_FIELD_TYPE_FREE_ACCESS',
  [IWhitelistTypeEnum.Discount]: 'ADMIN_WHITELIST_FIELD_TYPE_DISCOUNT',
  [IWhitelistTypeEnum.GateOnlyAccess]: 'ADMIN_WHITELIST_FIELD_TYPE_GATE_ONLY_ACCESS',
};
